import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CharacteristicResponse } from 'src/app/models/characteristic-response.model'

@Injectable({
  providedIn: 'root',
})
export class CharacteristicService {
  public static readonly characteristicEndpoint = '/characteristic'

  constructor(private readonly http: HttpClient) {}

  getCharacteristic(
    fundId: string,
    isInternal: boolean,
    isBfpCharacteristicsToggle: boolean,
  ): Observable<CharacteristicResponse> {
    const params = new HttpParams()
      .set('isInternal', String(isInternal))
      .set('isBfpCharacteristicsToggle', String(isBfpCharacteristicsToggle))
    return this.http.get<CharacteristicResponse>(
      `vmf/api/${fundId}`.concat(CharacteristicService.characteristicEndpoint),
      { params },
    )
  }
}
